/*
 * Renders multiple Comment Threads by component
 */
import React from 'react';
import { CommentThreadContent } from './comment_thread.jsx';

const FormComments = ({ comments = [], commentSendUrl, commentEditUrl, commentDeleteUrl, commentToggleThreadUrl, commentPermissions, ...rest }) => {
  return <>
    {comments.map((c, i) => (
      // Add commentPermissions if needed outside of PDF
      <div key={i} className="page-break-before">
        {/* // Don't show empty threads if no create permission. */}
        {(!commentPermissions.create && comments.length == 0) || !commentPermissions.view ? null : <CommentThreadContent
          key={c.id}
          boundTo={c.id}
          comments={{ [c.id]: c.comments }}
          title={c.name}
          open={c.open}
          showInSidebar={false}
          commentPermissions={commentPermissions}
          commentSendUrl={commentSendUrl?.replace("__thread__", c.id)}
          commentEditUrl={commentEditUrl?.replace("__thread__", c.id)}
          commentDeleteUrl={commentDeleteUrl?.replace("__thread__", c.id)}
          commentToggleThreadUrl={commentToggleThreadUrl?.replace("__thread__", c.id)}
          {...rest}
        />}
      </div>
    ))}
  </>
}

export default FormComments;